
import Vue from 'vue'
export default Vue.extend({
  props: {
    scrollable: {
      type: Boolean,
      default: false,
    },
  },
})
